import React from 'react';

import { api } from 'api';
import Spinner from 'jsx/elements/spinner';

import { ApplicationInfo } from './ApplicationInfo';
import { useRouteMatch } from 'react-router';
import Warning from 'jsx/elements/messages/Warning';
import { LoanFreezeApplicationForm } from './LoanFreezeApplicationForm';
export const ApplicationDetails = () => {
  const [data, setData] = React.useState(null);
  const match = useRouteMatch('/umsoknir/umsokn/:applicationID');
  const [message, setMessage] = React.useState(null);

  React.useEffect(() => {
    api.getApplication(match.params.applicationID).then(data => setData(data));
  }, []);

  if (!data) return <Spinner center size="medium" />;

  return (
    <>
      <h2 className="text-gray-dark text-28">Umsókn um frystingu lána / brúarlán</h2>
      {message && <Warning messageType={message.type} messageHeader={message.message} />}
      {data && <ApplicationInfo application={data} showMessage={m => setMessage(m)} />}

      {data && <LoanFreezeApplicationForm form={data} />}
      <div
        className="gutter-top"
        style={{ display: 'flex', justifyContent: 'space-between' }}
      ></div>
      <div className="gutter-top"></div>
    </>
  );
};
